/* formatProps is a hack to convert a `null` prop to `undefined`.
Why? Because React considers `null` to be an explicity-set value.
This means that if a prop is `null`, it will not default to the default prop type specified.

It will only set the default prop type for `undefined` values.

If you're using this to auto-populate inputs, using "null" or "undefined"
is not allowed by React, so a truthy second param will return an empty string.
Learn more here: https://reactjs.org/docs/forms.html#controlled-components */
export const formatProps = (prop, input) => prop || (input ? '' : undefined)
